import React, { useState } from "react";
import Input from "../../../components/ui/inputs/input/Input";
import "./SearchBar.scss";
import { Button } from "react-bootstrap";
import Iconify from "../../../layouts/components/iconify/iconify";

function SearchBar(props) {
  const [inputValue, setInputValue] = useState(props.searchValue || "");

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    if (props.handleChange) {
      props.handleChange(e);
    }
  };

  const clearInput = () => {
    setInputValue("");
    if (props.handleChange) {
      props.handleChange({ target: { value: "" } });
    }
  };

  return (
    <React.Fragment>
      <div className="search-section">
        <div className="search-part">
          <Input
            name="searchValue"
            type="text"
            value={inputValue}
            placeholder={props.searchText}
            onChange={handleInputChange}
          />
          {inputValue && (
            <button className="clear-btn" onClick={clearInput}>
              <Iconify icon="eva:close-fill"/>
            </button>
          )}
          <div className="search-btn">
            <Button title="Search">
              {/* <Image
                imagePath={AppIcons.searchIcon}
                imgCustomClassName="open-bar"
                altText="Icon"
              /> */}
              <span className="bi bi-search"></span>
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SearchBar;
